var assocDelete = require('./_assocDelete');

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      array = data.array;

  return array ? assocDelete(array, key) : data.map['delete'](key);
}

module.exports = stackDelete;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/node_modules/lodash/_stackDelete.js
// module id = ./node_modules/react-touch/node_modules/lodash/_stackDelete.js
// module chunks = main